import { isNumber, isObject } from "lodash-es";
import { To } from "react-router";
import { NavigateOptions, useNavigate } from "react-router-dom";

import { useSelector } from "../store";

const useNavigateWithSearch = (): ((
  to: To | number,
  options?: NavigateOptions,
) => void) => {
  const navigate = useNavigate();
  const { organizationId, clusterId } = useSelector((state) => state.current);

  return (to: To | number, options?: NavigateOptions) => {
    if (isObject(to)) {
      navigate(to, options);
      return;
    }
    if (isNumber(to)) {
      navigate(to);
      return;
    }
    const hasSearch = (to as string).includes("?");
    const urlParams = hasSearch
      ? new URLSearchParams(to as string)
      : new URLSearchParams();
    if (organizationId && !urlParams.get("oid")) {
      urlParams.set("oid", organizationId);
    }
    if (clusterId && !urlParams.get("cid")) {
      urlParams.set("cid", clusterId);
    }
    const decoded = decodeURIComponent(urlParams.toString());
    const dest = hasSearch ? decoded : to + "?" + decoded;
    navigate(dest, options);
  };
};

export default useNavigateWithSearch;
